<template>
  <div class="help-center">
    <div>
      <div class="help-header">Hi, we're here to help.</div>
      <div class="help-header-desc">
        Find answers to all your burning questions.
      </div>
      <div class="help-section">
        <div class="help-box" @click="setHelpArea('faq')">
          <div class="help-icon">
            <svg
              fill="none"
              height="100%"
              viewBox="0 0 48 48"
              width="100%"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                clip-rule="evenodd"
                d="m18.5 6c-8.0081 0-14.5 6.4919-14.5 14.5 0 18 24 21.5 24 21.5v-7h1.5c8.0081 0 14.5-6.4919 14.5-14.5s-6.4919-14.5-14.5-14.5zm11.8565 6.7347c1.598 1.2063 2.6435 3.0461 2.6435 5.4114 0 2.8806-1.8262 4.6852-3.6347 5.6819-1.0718.5906-2.2414.9678-3.2987 1.1924-.011 1.0952-.9022 1.9796-1.9999 1.9796-1.1046 0-2-.8954-2-2v-1.7135c0-1.0567.822-1.9311 1.8766-1.9962.9542-.059 2.3774-.3517 3.4914-.9656 1.0804-.5954 1.5653-1.2896 1.5653-2.1786 0-1.0616-.417-1.7384-1.0534-2.2189-.7043-.5316-1.775-.8792-3.0284-.9226-1.2447-.0432-2.4846.222-3.4262.7047-.946.4848-1.4116 1.0827-1.553 1.642-.2709 1.0709-1.3585 1.7194-2.4294 1.4486-1.0708-.2708-1.7194-1.3585-1.4485-2.4293.5085-2.0108 1.9929-3.394 3.6063-4.221 1.6178-.8292 3.5466-1.2065 5.3894-1.1426 1.8341.0636 3.7697.5727 5.2997 1.7277zm-8.3565 17.2653c0-1.1045.8954-2 2-2s2 .8955 2 2c0 1.1046-.8954 2-2 2s-2-.8954-2-2z"
                fill="#000"
                fill-rule="evenodd"
              />
            </svg>
          </div>
          <div class="help-box-title">FAQ</div>
        </div>
        <div class="help-box" @click="setHelpArea('guides')">
          <div class="help-icon">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              height="100%"
              viewBox="0 0 24 24"
              width="100%"
            >
              <path
                d="M3 6c-.55 0-1 .45-1 1v13c0 1.1.9 2 2 2h13c.55 0 1-.45 1-1s-.45-1-1-1H5c-.55 0-1-.45-1-1V7c0-.55-.45-1-1-1zm17-4H8c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zm-2 9h-8c-.55 0-1-.45-1-1s.45-1 1-1h8c.55 0 1 .45 1 1s-.45 1-1 1zm-4 4h-4c-.55 0-1-.45-1-1s.45-1 1-1h4c.55 0 1 .45 1 1s-.45 1-1 1zm4-8h-8c-.55 0-1-.45-1-1s.45-1 1-1h8c.55 0 1 .45 1 1s-.45 1-1 1z"
              />
            </svg>
          </div>
          <div class="help-box-title">Guides</div>
        </div>
        <div class="help-box" @click="setHelpArea('community')">
          <div class="help-icon">
            <svg
              fill="none"
              height="100%"
              viewBox="0 0 16 16"
              width="100%"
              xmlns="http://www.w3.org/2000/svg"
            >
              <g fill="#212121">
                <path
                  d="m3 3c0-1.10457.89543-2 2-2s2 .89543 2 2c0 .64476-.3051 1.21826-.7788 1.584-.01425.01051-.02841.02115-.04247.0319-.33054.24153-.73799.3841-1.17873.3841-1.10457 0-2-.89543-2-2z"
                />
                <path
                  d="m9.7788 4.584c.01425.01051.02841.02115.04247.03191.33053.24153.73803.38409 1.17873.38409 1.1046 0 2-.89543 2-2s-.8954-2-2-2c-1.10457 0-2 .89543-2 2 0 .64476.3051 1.21826.7788 1.584z"
                />
                <path
                  d="m6.26756 6c.34581-.5978.99216-1 1.73244-1s1.38663.4022 1.73244 1c.17017.29417.26756.63571.26756 1 0 1.10457-.89543 2-2 2s-2-.89543-2-2c0-.36429.09739-.70583.26756-1z"
                />
                <path
                  d="m2.49998 6h2.67073c-.11056.31278-.17071.64936-.17071 1 0 .76835.28885 1.46924.76389 2h-.26391c-1.08514 0-2.00878.69139-2.35451 1.6576-.33996-.1383-.65449-.319-.93332-.5428-.75318-.60453-1.21215-1.49872-1.21215-2.6148 0-.82839.67156-1.5 1.49998-1.5z"
                />
                <path
                  d="m10.5 9c1.0851 0 2.0088.69137 2.3545 1.6576.34-.1383.6545-.319.9334-.5428.7531-.60453 1.2121-1.49872 1.2121-2.6148 0-.82843-.6716-1.5-1.5-1.5h-2.6707c.1105.31278.1707.64936.1707 1 0 .76835-.2889 1.46924-.7639 2z"
                />
                <path
                  d="m11.8871 10.928c.0727.1763.1129.3695.1129.572 0 1.1161-.459 2.0103-1.2121 2.6148-.7413.595-1.73482.8852-2.7879.8852s-2.04658-.2902-2.78785-.8852c-.75318-.6045-1.21215-1.4987-1.21215-2.6148 0-.2025.04015-.3957.11292-.572.22486-.5447.76119-.928 1.38706-.928h5.00002c.6259 0 1.1622.3833 1.3871.928z"
                />
              </g>
            </svg>
          </div>
          <div class="help-box-title">Community</div>
        </div>
      </div>

      <div class="help-section second-row">
        <div class="help-box" @click="setHelpArea('troubleshoot')">
          <div class="help-icon">
            <svg
              viewBox="0 0 512 512"
              width="100%"
              height="100%"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="m501.1 395.7-117.1-117.1c-23.1-23.1-57.6-27.6-85.4-13.9l-106.6-106.6v-62.1l-128-96-64 64 96 128h62.1l106.6 106.6c-13.6 27.8-9.2 62.3 13.9 85.4l117.1 117.1c14.6 14.6 38.2 14.6 52.7 0l52.7-52.7c14.5-14.6 14.5-38.2 0-52.7zm-169.4-170.7c28.3 0 54.9 11 74.9 31l19.4 19.4c15.8-6.9 30.8-16.5 43.8-29.5 37.1-37.1 49.7-89.3 37.9-136.7-2.2-9-13.5-12.1-20.1-5.5l-74.4 74.4-67.9-11.3-11.3-67.9 74.4-74.4c6.6-6.6 3.4-17.9-5.7-20.2-47.4-11.7-99.6.9-136.6 37.9-28.5 28.5-41.9 66.1-41.2 103.6l82.1 82.1c8.1-1.9 16.5-2.9 24.7-2.9zm-103.9 82-56.7-56.7-152.4 152.5c-25 25-25 65.5 0 90.5s65.5 25 90.5 0l123.6-123.6c-7.6-19.9-9.9-41.6-5-62.7zm-163.8 165c-13.2 0-24-10.8-24-24 0-13.3 10.7-24 24-24s24 10.7 24 24c0 13.2-10.7 24-24 24z"
              />
            </svg>
          </div>
          <div class="help-box-title">Troubleshoot</div>
        </div>
        <div class="help-box" @click="setHelpArea('safety')">
          <div class="help-icon">
            <svg
              width="100%"
              height="100%"
              viewBox="0 0 1024 1024"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M512 64L128 192V576C128 788.1 299.9 960 512 960C724.1 960 896 788.1 896 576V192L512 64ZM791.357 506.5C791.357 678.8 684.3 888 512 888C339.7 888 791.357 963.8 791.357 791.5L758.715 767L791.357 734.5L824 246L791.357 506.5Z"
                fill="black"
              />
              <path
                d="M378.4 475.1C375.063 471.748 371.097 469.088 366.729 467.273C362.362 465.459 357.679 464.524 352.95 464.524C348.22 464.524 343.537 465.459 339.17 467.273C334.802 469.088 330.836 471.748 327.5 475.1C324.148 478.437 321.488 482.403 319.673 486.77C317.858 491.138 316.924 495.82 316.924 500.55C316.924 505.28 317.858 509.963 319.673 514.33C321.488 518.697 324.148 522.663 327.5 526L456.9 655.4L459 657.5C462.156 660.662 465.904 663.171 470.031 664.882C474.158 666.594 478.582 667.475 483.05 667.475C487.517 667.475 491.941 666.594 496.068 664.882C500.195 663.171 503.943 660.662 507.1 657.5L730.6 434C733.762 430.844 736.27 427.095 737.982 422.968C739.694 418.842 740.575 414.418 740.575 409.95C740.575 405.482 739.694 401.059 737.982 396.932C736.27 392.805 733.762 389.056 730.6 385.9L727.8 383.1C724.643 379.938 720.895 377.429 716.768 375.718C712.641 374.006 708.217 373.125 703.75 373.125C699.282 373.125 694.858 374.006 690.731 375.718C686.604 377.429 682.856 379.938 679.7 383.1L483 579.7L378.4 475.1Z"
                fill="white"
              />
            </svg>
          </div>
          <div class="help-box-title">Safety</div>
        </div>
        <div class="help-box" @click="setHelpArea('legal')">
          <div class="help-icon">
            <svg
              fill="none"
              height="100%"
              viewBox="0 0 48 48"
              width="100%"
              xmlns="http://www.w3.org/2000/svg"
            >
              <g fill="#000">
                <path
                  d="m40.8992 19.5969-3.716-8.0513c.271-.2458.488-.5452.6373-.8792.1492-.3341.2275-.69548.2298-1.06135-.0023-.59379-.2065-1.16913-.5792-1.63139s-.8917-.78392-1.4715-.91205-1.1859-.05512-1.7187.20704c-.5328.26215-.9605.69783-1.2128 1.23537l-18.7863 4.77568c-.4634-.3986-1.0541-.6183-1.6653-.6193-.5303-.0036-1.049.155-1.4866.4545-.4377.2995-.7733.7256-.962 1.2212-.18864.4956-.22132 1.0371-.0936 1.5518.1277.5147.4096.9781.8081 1.328l-3.81233 8.2577 11.07913-.0413-3.7986-8.2577c.4048-.3629.6842-.8447.7983-1.3763l6.7851-1.7203v21.1397h-.1377l-9.166 2.849c-.2932.0928-.5495.2758-.7324.523-.1829.2471-.283.5458-.2861.8532v.0964c-.0119.1935.0172.3873.0855.5688.0682.1814.174.3464.3104.4842.1365.1377.3004.2451.4813.315.1808.0699.3743.1009.5679.0908h21.8692c.1924.0099.3847-.0207.5645-.0898s.3431-.1752.4793-.3114c.1362-.1363.2423-.2995.3115-.4794.0691-.1798.0997-.3721.0898-.5645v-.1101c-.0021-.3057-.1002-.6031-.2805-.85-.1803-.247-.4336-.4311-.7242-.5262l-9.1523-2.849h-.1514v-22.0205l7.3219-1.9406.2752.289-3.7297 8.0788c.8236 0 10.2142-.0275 10.969-.0275zm-31.55826 5.8767 3.27556-7.1016 3.2301 7.07zm26.14946-12.7719 3.193 6.8814h-6.4273z"
                />
                <path
                  d="m20.1198 25.2178c0 4.1421-3.3579 7.5-7.5 7.5-4.14212 0-7.49999-3.3579-7.49999-7.5 8.26919.0002 6.53849 0 14.99999 0z"
                />
                <path
                  clip-rule="evenodd"
                  d="m12.6198 30.7178c2.332 0 4.325-1.4513 5.1251-3.5-1.9126 0-3.1336 0-4.1717 0-1.741.0001-2.9674.0001-6.07843 0 .80009 2.0487 2.79313 3.5 5.12503 3.5zm-7.23037-3.5c-.17573-.6367-.26962-1.3074-.26962-2h2c3.39799.0001 4.64959.0001 6.46529 0h4.5347 2v.0027c-.0002.6916-.0941 1.3614-.2696 1.9973-.8753 3.1712-3.7809 5.5-7.2304 5.5-3.44952 0-6.35512-2.3288-7.23037-5.5z"
                  fill-rule="evenodd"
                />
                <path
                  d="m42.5256 19.5134c0 4.1422-3.3579 7.5-7.5 7.5-4.1422 0-7.5-3.3578-7.5-7.5 8.2692.0002 6.5384 0 15 0z"
                />
                <path
                  clip-rule="evenodd"
                  d="m35.0256 25.0134c2.332 0 4.325-1.4513 5.125-3.5-1.9125 0-3.1335.0001-4.1716.0001-1.741 0-2.9675 0-6.0785 0 .8001 2.0486 2.7931 3.4999 5.1251 3.4999zm-7.2304-3.5c-.1757-.6367-.2696-1.3074-.2696-2 .7424 0 1.4042.0001 2 .0001h6.4653c1.1018 0 2.4115-.0001 4.5347-.0001h2v.0027c-.0003.6917-.0941 1.3614-.2696 1.9973-.8753 3.1712-3.7809 5.5-7.2304 5.5-3.4496 0-6.3552-2.3288-7.2304-5.5z"
                  fill-rule="evenodd"
                />
              </g>
            </svg>
          </div>
          <div class="help-box-title">Legal</div>
        </div>
      </div>

      <div class="help-section contact-section">
        <div class="help-box contact-box">
          <div class="contact-box-title">
            Didn't find the answers your were looking for? <br />
            No worries, we've got you!
          </div>
          <button class="info-box-button">Contact us</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
/**
 * Sections:
 * [x] FAQ — What is Cofocus? Who is it for?
 * [x] Guides — Getting Started
 * [x] Community
 * [x] Troubleshoot
 * [x] Safety
 * [x] Legal
 * [ ] Account & Billing
 * [ ] Support & Contact
 * [ ] Tips & Tricks
 */
export default {
  name: "HelpCenter",
  methods: {
    setHelpArea(area) {
      this.$emit("setHelpArea", area);
    },
  },
};
</script>

<style scoped>
.help-center {
  width: 100%;
  display: flex;
  justify-content: center;
  overflow-y: scroll;
}
.help-header {
  text-align: center;
  font-size: 42px;
  font-weight: 600;
  /* margin-top: 120px; */
  margin-top: 60px;
}
.help-header-desc {
  text-align: center;
  font-size: 22px;
  margin-top: 25px;
}
.help-section {
  display: flex;
  flex-direction: row;
  margin-top: 30px;
}
.help-section.second-row {
  margin-top: 0px;
}
.help-section.contact-section {
}
.help-box {
  width: 245px;
  margin: 0 18px;
  padding: 40px 10px;
  border-radius: 12px;
  background-color: white;
  box-shadow: rgb(15 15 15 / 5%) 0px 0px 0px 1px,
    rgb(62 62 62 / 10%) 0px 3px 6px, rgb(122 122 122 / 20%) 0px 9px 24px;
  box-sizing: border-box;
  margin-bottom: 40px;
  display: flex;
  justify-content: center;
  flex-direction: column;
  cursor: pointer;
}
.help-box.contact-box {
  width: 807px;
  cursor: default;
  color: black;
  background-color: transparent;
  box-shadow: unset;
}
.help-icon {
  width: 75px;
  height: 75px;
  margin: 0px auto;
}
.help-box-title {
  margin-top: 16px;
  font-weight: 600;
  padding: 8px 14px;
  height: 42px;
  box-sizing: border-box;
  display: flex;
  align-items: center;
  justify-content: center;
  border: 1px solid transparent;
  font-size: 28px;
  line-height: 22px;
}
.info-box-text {
  font-weight: 600;
  padding: 8px 14px;
  height: 42px;
  margin-right: 8px;
  box-sizing: border-box;
  display: flex;
  align-items: center;
  border: 1px solid transparent;
  font-size: 16px;
  font-weight: 400;
  margin-top: 10px;
}
.contact-box-title {
  margin-top: 16px;
  font-weight: 400;
  padding: 8px 14px;
  height: 42px;
  box-sizing: border-box;
  display: flex;
  align-items: center;
  border: 1px solid transparent;
  line-height: 44px;
  width: 700px;
  margin-bottom: 12px;
  margin-left: auto;
  margin-right: auto;
  font-size: 26px;
  text-align: center;
  justify-content: center;
  color: #111;
}
.info-box-button {
  margin: 0 auto;
  box-sizing: border-box;
  display: flex;
  align-items: center;
  cursor: pointer;
  border: 1px solid transparent;
  margin-top: 28px;
  background-color: #111;
  color: white;
  font-weight: 700;
  border-radius: 360px;
  width: 155px;
  padding: 4px 13px;
  height: 46px;
  text-align: center;
  justify-content: center;
  font-size: 24px;
}
.info-box-button:hover {
  background-color: #555;
}
</style>